/// <amd-module name="Environments/ProviderCreateDetails/VirtualMachines/Stores/VirtualMachineResourceStore" />

import { StoreBase, IStoreState } from "Environments/Flux/Store";
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { VirtualMachineResourceActions } from "Environments/ProviderCreateDetails/VirtualMachines/Actions/VirtualMachineResourceActions";
import { Operations } from "Environments/ProviderCreateDetails/VirtualMachines/Utilities";

import { PackageMetadata } from "DistributedTask/Client/Contracts/TaskAgent";

export interface IVirtualMachineResourceStoreState extends IStoreState {
    targetPackages: { [key: string]: PackageMetadata };
}

export class VirtualMachineResourceStore extends StoreBase {
    public static getKey(): string {
        return "virtualmachine-resource-add-store";
    }

    public initialize(instanceId: string): void {
        super.initialize(instanceId);

        this._actionsHub = ActionsHubManager.GetActionsHub<VirtualMachineResourceActions>(VirtualMachineResourceActions, instanceId);
        this._actionsHub.setTargetPackages.addListener(this._setTargetPackages);
    }

    public getState(): IVirtualMachineResourceStoreState {
        return this._state;
    }

    protected disposeInternal(): void {
        this._actionsHub.setTargetPackages.removeListener(this._setTargetPackages);
    }

    private _setTargetPackages = (targetPackages: PackageMetadata[]) => {
        for (let targetPkg of targetPackages) {
            this._state.targetPackages[targetPkg.platform] = targetPkg;
        }

        this.emit(Operations.UpdatePackage, this);
    }

    private _actionsHub: VirtualMachineResourceActions;
    private _state: IVirtualMachineResourceStoreState = {
        targetPackages: {},
    } as IVirtualMachineResourceStoreState;
}